import React, { createContext, useContext } from 'react';
import { Form } from 'react-final-form';
import { PropTypes } from 'prop-types';
import {
  Button, Modal, ModalBody, ModalFooter, ModalHeader
} from 'reactstrap';

const FormContext = createContext(null);

export function useRFFormContext() {
  return useContext(FormContext);
}

const RFForm = (props) => {
  const renderButtons = () => {
    if (props.footer) {
      return props.footer;
    } else {
      return (
        <>
          <Button type="submit" color="primary">Mentés</Button>
          <Button type="button" color="secondary" onClick={props.cancelFunction}>
            Mégse
          </Button>
        </>
      );
    }
  };

  const MHeader = () => { return (props.modalInsert ? <ModalHeader>{props.title}</ModalHeader> : <ModalHeader {...props.tagProps}>{props.title}</ModalHeader>)};

  
  const renderModal = () => {
    return (
      <>
       <MHeader />
        <ModalBody>
            {props.children}
        </ModalBody>
        <ModalFooter>
          {renderButtons()}
        </ModalFooter>
      </>
    )
  }

  const renderForm = () => {
    return (
      <Form {...props}
        // values-ból új object van csinálva, mert különben referencián keresztül az onSubmit metódusban lévő módosítások változtathatják a form-ban lévő mezők tartalmát
        onSubmit={(values) => props.onSubmit(null, {...values})}
        validate={props.validate}
        validateOnBlur
        initialValues={props.initialValues}
        render={({ form, handleSubmit }) => (
          <FormContext.Provider value={{ change: form.change }}>
            <form onSubmit={handleSubmit}>
              {props.modal || props.modalInsert ? renderModal() : props.children}
            </form>
          </FormContext.Provider>
        )}
      />
    );
  }

  return (
    (props.modalInsert) ? (
      <Modal {...props.tagProps}>
        {renderForm()}
      </Modal>
    ) : (
      renderForm()
    ))
};

RFForm.propTypes = {
  onSubmit: PropTypes.func,
  validate: PropTypes.object,
  children: PropTypes.node,
  // modal és modalInsert paraméterektől függően a <Modal> vagy a <ModalHeader> tag fogja megkapni
  tagProps: PropTypes.object,
  title: PropTypes.string,
  footer: PropTypes.node,
  cancelFunction: PropTypes.func,
  // Átírás utáni struktúrától függően modal vagy modalInsert paraméter kell,
  // ha valamilyen formában Modal-on belül jelenik meg a form (és szükség van az RFFormon belüli ModalHeader/Body/Footer struktúrára)

  // modal paramétert kell használni, ha a form egy modalba van építve, de a <Modal> tag az RFFormon kívül van
  // A ModalHeader kapja meg a tagProps-t
  modal: PropTypes.bool,
  // modalInsert paramétert kell használni a modal paraméter HELYETT, ha a form egy modalba van építve,
  // de az RFFormnak kell tartalmaznia a <Modal> tag-et belül
  // A Modal kapja meg a tagProps-t
  modalInsert: PropTypes.bool
};

export default RFForm;
export { FormContext };
